export const ButtonStyle = {
  FILLED: 'filled-button',
  OUTLINE: 'outlined-button',
  BASIC: 'basic-button',
  TRANSPARENT: 'transparent',
};

export type ButtonStyle = (typeof ButtonStyle)[keyof typeof ButtonStyle];

export const ButtonShape = {
  DEFAULT: 'default',
  ROUNDED: 'rounded',
};
export type ButtonShape = (typeof ButtonShape)[keyof typeof ButtonShape];
